import React from 'react';
import { ChevronLeft } from 'lucide-react';

interface ToolHeaderProps {
  title: string;
  onBack?: () => void;
  backLabel?: string;
  rightAction?: React.ReactNode;
}

export function ToolHeader({ title, onBack, backLabel = 'Back', rightAction }: ToolHeaderProps) {
  return (
    <div className="flex items-center justify-between px-6 py-4 mb-4">
      {/* Left - Back button */}
      <div className="w-24">
        {onBack && (
          <button
            onClick={onBack}
            className="flex items-center gap-1.5 px-3 py-2 text-purple-600 hover:bg-white/30 rounded-xl transition-all text-sm font-medium"
          >
            <ChevronLeft className="w-4 h-4" />
            <span>{backLabel}</span>
          </button>
        )}
      </div>

      {/* Center - Title */}
      <h2 className="text-lg font-semibold text-purple-800 flex items-center gap-2">
        {title}
      </h2>

      {/* Right - Action */}
      <div className="w-24 flex justify-end">
        {rightAction}
      </div>
    </div>
  );
}

export default ToolHeader;
